import { capitalizeFirstLetter } from '@visalex/core';

import { PostWithPath } from '../types';

/**
 * Function that transforms posts to SelectOption array
 * @param allPostsList
 */
export const getOptions = (allPostsList: PostWithPath[]) => {
  return allPostsList.map((post) => {
    return {
      value: post.path,
      label: post.post.title,
    };
  });
};

/**
 * Function that returns an array of path for breadcrumbs
 * @param linkPath
 */
export const getPathArray = (linkPath: string[]) => {
  linkPath.shift();

  return linkPath.map((path, i) => {
    return {
      breadcrumb: capitalizeFirstLetter(path.split('-').join(' ')),
      href: `/${linkPath.slice(0, i + 1).join('/')}`,
    };
  });
};
